import { createFileRoute } from '@tanstack/react-router';
import { SkillLibraryPage } from '../settings/skills/components/SkillLibraryPage';

export const Route = createFileRoute('/skills/library')({
  component: SkillLibraryPage,
});
